module.exports = __webpack_public_path__ + "static/fonts/Fact-Compressed.19ee27d.ttf";